import { ContraIndicationsAlert } from '../../../ContraIndicationsAlert';

export function ContraIndicationsOsas() {
    return (
        <ContraIndicationsAlert
            absoluteContraIndications="Patiënt gebruikt alfablokkers,Patiënt heeft een permanente pacemaker"
            absoluteContraIndicationsTitle="Absolute contra-indicaties"
            disclaimer="&#42;Het gebruik van kortwerkende nitraten langer dan 3 uur voorafgaand aan het onderzoek is
        toegestaan."
            relativeContradictions="Patiënt gebruikt kortwerkende nitraten&#42;"
            relativeContradictionsTitle="Relatieve contra-indicaties"
            subtitle="Voor deze zorg is een slaaponderzoek vereist."
            title="Contra-indicaties voor slaaponderzoek"
        />
    );
}
